// src/pages/Home.js
import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import CookieConsent from "react-cookie-consent";

// Imports des composants qui ne servent que sur la page d'accueil
import Hero from '../components/Hero';
import Services from '../components/Services';
import About from '../components/About';
import Testimonials from '../components/Testimonials';
import QuoteForm from '../components/QuoteForm';
import LocalSeo from '../components/LocalSeo';
import Footer from '../components/Footer';
import LegalNotice from '../components/LegalNotice';

// ATTENTION : On renomme la fonction en "Home" ici
const Home = () => {
  const [showLegalNotice, setShowLegalNotice] = useState(false);

  const handleToggleLegalNotice = (e) => {
    if (e) e.preventDefault();
    setShowLegalNotice(!showLegalNotice);
  };

  return (
    <div className="home-page">
      <Helmet>
        <title>Électricien La Réunion &amp; Le Tampon | TechniServices</title>
        <meta name="description" content="Entreprise d'électricité à La Réunion. Dépannage d'urgence, rénovation aux normes NF C 15-100 &amp; domotique au Tampon et Trois Mares. Devis gratuit !" />
        <meta property="og:title" content="Électricien La Réunion &amp; Le Tampon | TechniServices" />
        <meta property="og:description" content="Entreprise d'électricité à La Réunion. Dépannage d'urgence, rénovation aux normes NF C 15-100 &amp; domotique au Tampon et Trois Mares. Devis gratuit !" />
        <link rel="canonical" href="https://techniservices.re/" />
      </Helmet>
      <main>
        <Hero />
        <Services />
        <About />
        <Testimonials />
        <QuoteForm />
        <LocalSeo />
      </main>
      
      {/* Le Footer est spécifique à la page d'accueil dans votre structure actuelle */}
      <Footer onLegalClick={handleToggleLegalNotice} />

      {showLegalNotice && <LegalNotice onClose={handleToggleLegalNotice} />}
      
      <CookieConsent
        location="bottom"
        buttonText="J'accepte"
        declineButtonText="Je refuse"
        enableDeclineButton
        cookieName="techniservicesCookieConsent"
        style={{ background: "#2B373B" }}
        buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
        expires={150}
        onAccept={() => {
          alert("Merci pour votre consentement !");
        }}
      >
        Ce site utilise des cookies pour analyser le trafic et améliorer l'expérience utilisateur.
      </CookieConsent>
    </div>
  );
};

export default Home;